import { useCallback, useState } from 'react'

export const useLocalStorage = <T>(key: string, initialValue: T) => {
  const getInitialValue = () => {
    if (typeof window === 'undefined') return initialValue

    try {
      const item = JSON.parse(localStorage.getItem(key) as string) as T

      return item ?? initialValue
    } catch {
      return initialValue
    }
  }

  const [valueLS, setValueLS] = useState(getInitialValue)

  const setValueToLocalStorage = useCallback(
    (value: T) => {
      if (typeof window !== 'undefined') localStorage.setItem(key, JSON.stringify(value))
      setValueLS(value)
    },
    [key],
  )

  return { valueLS, setValueLS: setValueToLocalStorage, getInitialValue }
}
